import { IconButton } from '@material-ui/core';
import ZoomInRoundedIcon from '@material-ui/icons/ZoomInRounded';
import ZoomOutRoundedIcon from '@material-ui/icons/ZoomOutRounded';

import { SText } from '@setvi/shared/components';

import type { Zoom } from '../../hooks/use-zoom';
import { useStyles } from '../../styles';

/** Zoom out / level / zoom in, shared by the PDF and image previews. */
export const ZoomControls = ({
  zoom,
  canZoomIn,
  canZoomOut,
  zoomIn,
  zoomOut
}: Zoom) => {
  const classes = useStyles();

  return (
    <>
      <IconButton
        className={classes.toolbarButton}
        size="small"
        title="Zoom out"
        disabled={!canZoomOut}
        onClick={zoomOut}>
        <ZoomOutRoundedIcon fontSize="small" />
      </IconButton>
      <SText
        title={`${Math.round(zoom * 100)}%`}
        size="sm"
        fontColor="#5D7083"
        className={classes.zoomLabel}
      />
      <IconButton
        className={classes.toolbarButton}
        size="small"
        title="Zoom in"
        disabled={!canZoomIn}
        onClick={zoomIn}>
        <ZoomInRoundedIcon fontSize="small" />
      </IconButton>
    </>
  );
};
